import spotifyPath from 'assets/factSources/spotify.svg'
import appleMusicPath from 'assets/factSources/appleMusic.svg'
import itunesPath from 'assets/factSources/itunes.svg'
import shazamPath from 'assets/factSources/shazam.svg'
import airplayPath from 'assets/factSources/airplay.svg'
import officialPath from 'assets/factSources/official.svg'

export const configMap = [
  {
    name: 'spotify',
    title: 'Spotify',
    iconPath: spotifyPath
  },
  {
    name: 'applemusic',
    title: 'Apple Music',
    iconPath: appleMusicPath
  },
  {
    name: 'itunes',
    title: 'itunes',
    iconPath: itunesPath
  },
  {
    name: 'shazam',
    title: 'Shazam',
    iconPath: shazamPath
  },
  {
    name: 'airplay',
    title: 'AirPlay',
    iconPath: airplayPath
  },
  {
    name: 'official',
    title: 'Official',
    iconPath: officialPath
  }
]

export const TOP_CHARTING_PRODUCTS_LIMIT = 5
